/**
 * Shared "section card" wrapper used across the four settings sections.
 * Pure visual — icon + tiny uppercase label header + children body, with
 * an optional `danger` flag that flips the border to red for destructive
 * sections (Data Management, Sign-out actions).
 */
export default function SettingsSectionCard({ icon: Icon, title, children, danger }) {
  return (
    <div className={`bg-card rounded-xl p-4 shadow-sm border ${danger ? 'border-red-500/30' : 'border-border'}`}>
      <div className="flex items-center gap-2 mb-3">
        <Icon size={14} className={danger ? 'text-red-500' : 'text-nav-blue'} />
        <span className="text-[10px] uppercase tracking-wider text-muted-foreground font-semibold">{title}</span>
      </div>
      {children}
    </div>
  );
}
